// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 14) return "static/js/fa2a33aca3668b8636e7.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"799c0d63af37757005fd","211":"cf3283993c5c0a5fc904","212":"13f132dac8cfdcd49389"}[chunkId] + ".chunk.js";
};